import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-nwsalert-options-component',
  standalone: false,
  templateUrl: './nwsalert-options-component.component.html',
  styleUrl: './nwsalert-options-component.component.css'
})
export class NWSAlertOptionsComponent {
  filterBy = "eventType";
  filterByOptions = [
              {label: "Show alerts for the entire United States filtering by event type", value:"eventType"}, 
              {label: "Show all alerts filtered by the state", value: "state"}];

	stateNames: any[] = [];
	selectedState = 'CO';

  eventTypes: any[] = [];
  selectedEventTypes: any[] = [];
  defaultEventTypes:any = [];

	constructor( 
		public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {

		this.createStateNamesList();
    this.createEventTypesList();
	}

  ngOnInit(): void {
    this.filterBy = this.config.data['filterBy'];
    this.selectedState = this.config.data['selectedState'];
    this.selectedEventTypes = this.config.data['selectedEventTypes'];
    this.defaultEventTypes = this.config.data['defaultEventTypes']
  }

  cancel() {
    this.ref.close(null)
  }

  apply() {
    this.ref.close({
      filterBy: this.filterBy,
      selectedState: this.selectedState,
      selectedEventTypes: this.selectedEventTypes});
  }

  resetDefaultEventTypes() {
    this.selectedEventTypes = JSON.parse(JSON.stringify(this.defaultEventTypes));
  }

  createEventTypesList() {
    this.eventTypes = [
      { name: "911 Telephone Outage Emergency" },
      { name: "Administrative Message" },
      { name: "Air Quality Alert" },
      { name: "Air Stagnation Advisory" },
      { name: "Arroyo And Small Stream Flood Advisory" },
      { name: "Ashfall Advisory" },
      { name: "Ashfall Warning" },
      { name: "Avalanche Advisory" },
      { name: "Avalanche Warning" },
      { name: "Avalanche Watch" },
      { name: "Beach Hazards Statement" },
      { name: "Blizzard Warning" },
      { name: "Blizzard Watch" },
      { name: "Blowing Dust Advisory" },
      { name: "Blowing Dust Warning" },
      { name: "Brisk Wind Advisory" },
      { name: "Child Abduction Emergency" },
      { name: "Civil Danger Warning" },
      { name: "Civil Emergency Message" },
      { name: "Coastal Flood Advisory" },
      { name: "Coastal Flood Statement" },
      { name: "Coastal Flood Warning" },
      { name: "Coastal Flood Watch" },
      { name: "Dense Fog Advisory" },
      { name: "Dense Smoke Advisory" },
      { name: "Dust Advisory" },
      { name: "Dust Storm Warning" },
      { name: "Earthquake Warning" },
      { name: "Evacuation Immediate" },
      { name: "Excessive Heat Warning" },
      { name: "Excessive Heat Watch" },
      { name: "Extreme Cold Warning" },
      { name: "Extreme Cold Watch" },
      { name: "Extreme Fire Danger" },
      { name: "Extreme Wind Warning" },
      { name: "Fire Warning" },
      { name: "Fire Weather Watch" },
      { name: "Flash Flood Statement" },
      { name: "Flash Flood Warning" },
      { name: "Flash Flood Watch" },
      { name: "Flood Advisory" },
      { name: "Flood Statement" },
      { name: "Flood Warning" },
      { name: "Flood Watch" },
      { name: "Freeze Warning" },
      { name: "Freeze Watch" },
      { name: "Freezing Fog Advisory" },
      { name: "Freezing Rain Advisory" },
      { name: "Freezing Spray Advisory" },
      { name: "Frost Advisory" },
      { name: "Gale Warning" },
      { name: "Gale Watch" },
      { name: "Hard Freeze Warning"  },
      { name: "Hard Freeze Watch" },
      { name: "Hazardous Materials Warning" },
      { name: "Hazardous Seas Warning" },
      { name: "Hazardous Seas Watch" },
      { name: "Hazardous Weather Outlook" },
      { name: "Heat Advisory" },
      { name: "Heavy Freezing Spray Warning" },
      { name: "Heavy Freezing Spray Watch" },
      { name: "High Surf Advisory" },
      { name: "High Surf Warning" },
      { name: "High Wind Warning" },
      { name: "High Wind Watch" },
      { name: "Hurricane Force Wind Warning" },
      { name: "Hurricane Force Wind Watch" },
      { name: "Hurricane Local Statement" },
      { name: "Hurricane Warning" },
      { name: "Hurricane Watch" },
      { name: "Hydrologic Advisory" },
      { name: "Hydrologic Outlook" },
      { name: "Ice Storm Warning" },
      { name: "Lake Effect Snow Advisory" },
      { name: "Lake Effect Snow Warning" },
      { name: "Lake Effect Snow Watch" },
      { name: "Lake Wind Advisory" },
      { name: "Lakeshore Flood Advisory" },
      { name: "Lakeshore Flood Statement" },
      { name: "Lakeshore Flood Warning" },
      { name: "Lakeshore Flood Watch" },
      { name: "Law Enforcement Warning" },
      { name: "Local Area Emergency" },
      { name: "Low Water Advisory" },
      { name: "Marine Weather Statement" },
      { name: "Nuclear Power Plant Warning" },
      { name: "Radiological Hazard Warning" },
      { name: "Red Flag Warning" },
      { name: "Rip Current Statement" },
      { name: "Severe Thunderstorm Warning" },
      { name: "Severe Thunderstorm Watch" },
      { name: "Severe Weather Statement" },
      { name: "Shelter In Place Warning" },
      { name: "Short Term Forecast" },
      { name: "Small Craft Advisory" },
      { name: "Small Craft Advisory For Hazardous Seas" },
      { name: "Small Craft Advisory For Rough Bar" },
      { name: "Small Craft Advisory For Winds" },
      { name: "Small Stream Flood Advisory" },
      { name: "Snow Squall Warning" },
      { name: "Special Marine Warning" },
      { name: "Special Weather Statement" },
      { name: "Storm Surge Warning" },
      { name: "Storm Surge Watch" },
      { name: "Storm Warning" },
      { name: "Storm Watch" },
      { name: "Test" },
      { name: "Tornado Warning" },
      { name: "Tornado Watch" },
      { name: "Tropical Depression Local Statement" },
      { name: "Tropical Storm Local Statement" },
      { name: "Tropical Storm Warning" },
      { name: "Tropical Storm Watch" },
      { name: "Tsunami Advisory" },
      { name: "Tsunami Warning" },
      { name: "Tsunami Watch" },
      { name: "Typhoon Local Statement" },
      { name: "Typhoon Warning" },
      { name: "Typhoon Watch" },
      { name: "Urban And Small Stream Flood Advisory" },
      { name: "Volcano Warning" },
      { name: "Wind Advisory" },
      { name: "Wind Chill Advisory" },
      { name: "Wind Chill Warning" },
      { name: "Wind Chill Watch" },
      { name: "Winter Storm Warning" },
      { name: "Winter Storm Watch" },
      { name: "Winter Weather Advisory" }
  ];

  }

  createStateNamesList() {
    this.stateNames = [
      {label: "Alabama", value: "AL"},
      {label: "Alaska", value: "Ak"},
      {label: "Arizona", value: "AZ"},
      {label: "Arkansas", value: "Ar"},
      {label: "California", value: "CA"},
      {label: "Colorado", value: "CO"},
      {label: "Connecticut", value: "CT"},
      {label: "Delaware", value: "DE"},
      {label: "Florida", value: "FL"},
      {label: "Georgia", value: "GA"},
      {label: "Hawaii", value: "HI"},
      {label: "Idaho", value: "ID"},
      {label: "Illinois", value: "IL"},
      {label: "Indiana", value: "IN"},
      {label: "Iowa", value: "IA"},
      {label: "Kansas", value: "KS"},
      {label: "Kentucky", value: "KY"},
      {label: "Louisiana", value: "LA"},
      {label: "Maine", value: "ME"},
      {label: "Maryland", value: "MD"},
      {label: "Massachusetts", value: "MA"},
      {label: "Michigan", value: "MI"},
      {label: "Minnesota", value: "MN"},
      {label: "Mississippi", value: "MS"},
      {label: "Missouri", value: "MO"},
      {label: "Montana", value: "MT"},
      {label: "Nebraska", value: "NE"},
      {label: "Nevada", value: "NV"},
      {label: "New Hampshire", value: "NH"},
      {label: "New Jersey", value: "NJ"},
      {label: "New Mexico", value: "NM"},
      {label: "New York", value: "NY"},
      {label: "North Carolina", value: "NC"},
      {label: "North Dakota", value: "ND"},
      {label: "Ohio", value: "OH"},
      {label: "Oklahoma", value: "OK"},
      {label: "Oregon", value: "OR"},
      {label: "Pennsylvania", value: "PA"},
      {label: "Rhode Island", value: "RI"},
      {label: "South Carolina", value: "SC"},
      {label: "South Dakota", value: "SD"},
      {label: "Tennessee", value: "TN"},
      {label: "Texas", value: "TX"},
      {label: "Utah", value: "UT"},
      {label: "Vermont", value: "VT"},
      {label: "Virginia", value: "VA"},
      {label: "Washington", value: "WA"},
      {label: "West Virginia", value: "WV"},
      {label: "Wisconsin", value: "WI"},
      {label: "Wyoming", value: "WY"},
    ] 
  }

}
